import React, { useEffect, useState } from "react"

//Components
import { Accordion, Input } from "components/anti"
import { useScrollAnim } from "components/hooks/hooks"
import { Q_FAQ_DESC } from "lib/graphql"
import { useLazyQuery } from "@apollo/client"
import { debounce } from "lodash"
import { staticApollo } from "lib/apollo"

const HelpPageComp = ({ locale }) => {
  // const [getFaq, { data: faqData, loading }] = useLazyQuery(Q_FAQ_DESC)

  //States ******************************************************** //
  const [trigger, anim] = useScrollAnim()
  const [faqData, setFaqData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")
  const onSearch = (e) => {
    setSearch(e)
  }

  const changeHeight = () => {
    setTimeout(() => {
      let arr = []
      document
        .querySelectorAll(".accordion-header")
        .forEach((el) => arr.push(el.clientHeight))
      document.querySelectorAll(".accordion-header").forEach((el) => {
        el.style.height = `${Math.max(...arr)}px`
      })
    }, [100])
  }

  const handleGetFaqData = async () => {
    setLoading(true)
    const client = staticApollo(`${process.env.INIT_TOKEN}`)
    const { data } = await client.query({
      query: Q_FAQ_DESC,
      variables: { lang: locale, s: search },
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    })
    setFaqData(data)
    setLoading(false)
  }

  useEffect(() => {
    changeHeight()
    window.addEventListener("resize", changeHeight)
    return () => window.removeEventListener("resize", changeHeight)
  }, [search])

  //FAQ search API
  useEffect(() => {
    handleGetFaqData()
    // getFaq({ variables: { lang: locale, s: search } })
  }, [search, locale])

  return (
    <section className="sc-help" ref={trigger}>
      <div className="container mw-md">
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => router.back()}
          />
        </div>
        <div className="wrapper-header">
          <h3 className="title-page">{locale === "id" ? "Bantuan" : "Help"}</h3>
          <div className={`search-field-wrapper mb-3 ${anim(1)}`}>
            <Input
              iconLeft
              // value={search}
              variant="underline"
              className="search-field"
              placeholder={
                locale === "id"
                  ? "Apa yang bisa kami bantu?"
                  : "What can we help you with?"
              }
              onChange={debounce((e) => onSearch(e.target.value), 500)}
            />
            <i className="ail ai-times" onClick={() => onSearch("")}></i>
          </div>
        </div>
        <div className="wrapper-content">
          {loading ? (
            <div className="common-loader ">
              <i className="ail ai-spinner-third" />
            </div>
          ) : (
            <div className="row faq-content">
              {faqData &&
                faqData?.faqs?.map((item, i) => (
                  <div className="col-12">
                    <div>
                      <Accordion
                        key={i}
                        variant="line"
                        className={anim(i + 2)}
                        title={item.title}
                        defaultExpanded={false}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                        {/* <p>{item.description}</p> */}
                      </Accordion>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
        {/* <div className="row">
          <div className="col-md-4">
            <div className="box-list">
              {cateState?.map((item, i) => (
                <div
                  key={i}
                  className={`help-box p-3 ${
                    state.key === i && "active"
                  } ${anim(i + 1)}`}
                  onClick={() => handleClickBox(i, item.id)}
                >
                  <p className="text-title-3">{item.title}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-8">
            {descState?.map((item, i) => (
              <div
                className={`desc-box ${anim(i + 1)}`}
                onClick={() => handleClickDesc(i)}
                key={i}
              >
                <Accordion
                  variant="line"
                  title={item.title}
                  expanded={state.expandedKey === i}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </Accordion>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  )
}

export default HelpPageComp
